// extracted by mini-css-extract-plugin
module.exports = {"communicationStyleWrapper":"Communication_communicationStyleWrapper__UMwp0"};